// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"f1c4ed57","542":"28294364","545":"2d508b8d","992":"2934350d"}[chunkId] + ".css";
};